export const dragSchedulableEntity = (ev, type, entityId, assignmentTypeId) => {
    ev.dataTransfer.setData('type', type);
    if (type === 'user' || type === 'asset') {
        ev.dataTransfer.setData('entityId', entityId);
        ev.dataTransfer.setData('assignmentTypeId', assignmentTypeId);
    }
};
